import { Lerp } from "slotworks/utils/math/lerp";

export default class Rectangle {

    public static Lerp(rectA: Rectangle, rectB: Rectangle, t: number): Rectangle {
        const lerpRect = new Rectangle();

        lerpRect.x = Lerp(rectA.x, rectB.x, t);
        lerpRect.y = Lerp(rectA.y, rectB.y, t);
        lerpRect.width = Lerp(rectA.width, rectB.width, t);
        lerpRect.height = Lerp(rectA.height, rectB.height, t);

        return lerpRect;
    }

    public x: number;
    public y: number;
    public width: number;
    public height: number;

    constructor(x = 0, y = 0, width = 0, height = 0) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }

    public clone(): Rectangle {
        return new Rectangle(this.x, this.y, this.width, this.height);
    }

    public toString(): string {
        return this.x.toString() + "," + this.y.toString() + "," + this.width.toString() + "," + this.height.toString();
    }
}
